const get = (item: any) => item?.trim?.() ?? ""

export function localize (locale: string, item: any) {
  if (!item) return ""
  if (typeof item === "string") return item
  return get(item[locale]) || Object.values(item).find(get) || ""
}
